<template>
  <v-navigation-drawer :value="panierDrawer" @input="SET_PANIER_DRAWER($event)" app right clipped class="pa-6" width="350">
    <Panier />
    <v-btn
      v-if="panier.length > 0"
      block
      x-large
      color="primary"
      :to="{ name: 'Caisse', query: { ...$route.query } }"
      @click="SET_PANIER_DRAWER(false)"
      >{{ $t("boutique.passerALaCaisse") }}</v-btn
    >
  </v-navigation-drawer>
</template>

<script>
import Panier from "@/components/boutique/Panier"
import { mapMutations, mapGetters } from "vuex"
export default {
  components: {
    Panier
  },
  methods: {
    ...mapMutations(["SET_PANIER_DRAWER"])
  },
  computed: {
    ...mapGetters(["panierDrawer", "panier"])
  }
}
</script>

<style>
</style>